import Vue from 'vue'
import {EpetJs} from '@/utils/epetsdk'
import Router from 'vue-router'
import store from '@/store/index'

Vue.use(Router)

/*
title:页面标题
keepAlive:true是否缓存页面
requiresAuth:true页面是否需要登录
{
  path:'/about/:id(\\d+)',
  name: 'about',
  alias:'/about',
  redirect:'http://www.baidu.com',
  component:  resolve => require(['@/pages/about/about'], resolve),
  beforeEnter(to,from,next){
    next();
  },
  meta:{title:'about'},
  children:[{
    path:'list',
    name:'list',
    component:  resolve => require(['@/pages/about/list'], resolve),
    meta:{title:'list'}
  }]
},
{ path: '/search', component: SearchUser, props: (route) => ({ query: route.query.q }) }

*/

const router = new Router({
  mode: 'history',
  base:'/',
  routes: [
    {
          path: '/index',
          name: 'index',
          component: resolve => require(['@/pages/index/main'], resolve),
          meta: { title: '首页', background: "#ffffff",class:'user-center' }
    },
  
    {
      path: '/inquire',
      name: 'alliance_inquire',
      component: resolve => require(['@/pages/alliance/inquire'], resolve),
      meta: { title: '它品联盟', background: "#ffffff",class:'alliance-inquire' }
    },//查询
	{
	  path: '/ire',
	  name: 'alliance_inquire',
	  component: resolve => require(['@/pages/alliance/inquire'], resolve),
	  meta: { title: '它品联盟', background: "#ffffff",class:'alliance-inquire' }
	},//短防伪码查询，沿用之前页面
    {
      path: '/alliance/result',
      name: 'alliance_result',
      component: resolve => require(['@/pages/alliance/result'], resolve),
      meta: { title: '它品联盟', background: "#f3f4f5",class:'alliance-result' }
    }, //查询结果
    {
      path: '/alliance/feedback',
      name: 'alliance_feedback',
      component: resolve => require(['@/pages/alliance/feedback'], resolve),
      meta: { title: '它品联盟', background: "#ffffff",class:'alliance-feedback' }
    },//异常反馈
    {
      path: '/alliance/store',
      name: 'alliance_store',
      component: resolve => require(['@/pages/alliance/store'], resolve),
      meta: { title: '它品联盟', background: "#ffffff",class:'alliance-store' }
    },//附近门店
    {
      path: '/alliance/detail',
      name: 'alliance_detail',
      component: resolve => require(['@/pages/alliance/detail'], resolve),
      meta: { title: '它品联盟', background: "#ffffff",class:'alliance-detail' }
    },//积分明细
    
    {
      path: '/alliance/exchange',
      name: 'alliance_exchange',
      component: resolve => require(['@/pages/alliance/exchange'], resolve),
      meta: { title: '它品联盟', background: "#ffffff",class:'alliance-exchange' }
    },//积分专区
    {
      path: '/alliance/myexchange',
      name: 'alliance_myexchange',
      component: resolve => require(['@/pages/alliance/myexchange'], resolve),
      meta: { title: '它品联盟', background: "#ffffff",class:'alliance-myexchange' }
    },//我的兑换
    {
      path: '/alliance/personal',
      name: 'alliance_personal',
      component: resolve => require(['@/pages/alliance/personal'], resolve),
      meta: { title: '它品联盟', background: "#ffffff",class:'alliance-personal' }
    },//个人资料
    {
      path: '/alliance/petinfo',
      name: 'alliance_petinfo',
      component: resolve => require(['@/pages/alliance/petinfo'], resolve),
      meta: { title: '它品联盟', background: "#ffffff",class:'alliance-petinfo' }
    },//宠物信息
    {
      path: '/alliance/bindphone',
      name: 'alliance_bindphone',
      component: resolve => require(['@/pages/alliance/bindphone'], resolve),
      meta: { title: '它品联盟', background: "#ffffff",class:'alliance-bindphone' }
    },//绑定手机
   
    {
      path: '/alliance/coupondetail',
      name: 'alliance_coupondetail',
      component: resolve => require(['@/pages/alliance/coupondetail'], resolve),
      meta: { title: '它品联盟', background: "#f3f4f5",class:'alliance-coupondetail' }
    },//优惠券详情
    {
      path: '/alliance/rule',
      name: 'alliance_rule',
      component: resolve => require(['@/pages/alliance/rule'], resolve),
      meta: { title: '它品联盟', background: "#ffffff",class:'alliance-rule' }
    },//规则
    {
      path: '/alliance/map',
      name: 'alliance_map',
      component: resolve => require(['@/pages/alliance/map'], resolve),
      meta: { title: '它品联盟', background: "#ffffff",class:'alliance-map' }
    },//地图
    {
      path: '/alliance/bindshop',
      name: 'alliance_bindshop',
      component: resolve => require(['@/pages/alliance/bindshop'], resolve),
      meta: { title: '它品联盟', background: "#ffffff",class:'alliance-bindshop'}
    },//绑定门店
    {
      path: '/alliance/shopcode',
      name: 'alliance_shopcode',
      component: resolve => require(['@/pages/alliance/shopcode'], resolve),
      meta: { title: '它品联盟', background: "#ffffff",class:'alliance-shopcode'}
    },//逛云店
    {
      path: '/alliance/mystore',
      name: 'alliance_mystore',
      component: resolve => require(['@/pages/alliance/mystore'], resolve),
      meta: { title: '它品联盟', background: "#f3f4f5",class:'alliance-mystore'}
    },//我的门店
    {
      path: '/alliance/cancelback',
      name: 'alliance_cancelback',
      component: resolve => require(['@/pages/alliance/cancelback'], resolve),
      meta: { title: '它品联盟', background: "#ffffff",class:'alliance-cancelback'}
    },//我的门店
    {
      path: '*',
      name:'404',
      component: resolve => require(['@/pages/404/404'], resolve)
	},
	{
      path: '/invite',
      name: 'alliance_invite',
      component: resolve => require(['@/pages/alliance/invite'], resolve),
      meta: { title: '枫趣代言官邀请', background: "#ffffff",class:'alliance-invite' }
    },//代言官邀请页
	{
	  path: '/coin',
	  name: 'alliance_coin',
	  component: resolve => require(['@/pages/alliance/coin'], resolve),
	  meta: { title: '赚品牌币', background: "#ffffff",class:'alliance-invite' }
	},//扫外包装获得币
    {
        path: '/haiji/inquire',
        name: 'haiji_inquire',
        component: resolve => require(['@/pages/haiji/inquire'], resolve),
        meta: { title: '正品查询', background: "#ffffff",class:'alliance-inquire' }
    },//正品查询
    {
        path: '/haiji/inquire_result',
        name: 'haiji_inquire_result',
        component: resolve => require(['@/pages/haiji/result'], resolve),
        meta: { title: '正品查询', background: "#ffffff",class:'alliance-inquire' }
    },//正品查询结果页
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y:0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  store.commit('loading',{'Loading':true})
  var petType = EpetJs.Common.getcookie('X15t_PET_TYPE') ? EpetJs.Common.getcookie('X15t_PET_TYPE'):'dog';
  store.commit('togglePetType',{petType:petType});
   //判断是ios还安卓
   var u = navigator.userAgent;
   var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
   if (isiOS && to.path !== location.pathname) {
     // 此处不可使用location.replace
     location.assign(to.fullPath)
	 window.history.replaceState(null, null, window.localtion.href);
   }
  /*
   设置页面title标题
  */
  if(to.meta.title){
    document.title = to.meta.title;
  }

  if(to.meta.background){
    document.body.style.backgroundColor = to.meta.background;
  }else{
    document.body.style.backgroundColor = "#f3f4f5";
  }
  /*
    设置页面class
   */
  if(to.meta.class){
    document.body.className = to.meta.class;
  }

  /*
  检测页面是否需要登录，如果需要且没有登录，自动跳转到登录页面
  */
  if(to.matched.some(record => record.meta.requiresAuth)){
    if(!store.state.isLogin){
      EpetJs.Common.locationTo('wap:login');
      next();
    }else{
      next();
    }
  }else{
    next();
  }
})

router.afterEach((to, from) => {
  store.dispatch('loading',{'Loading':false})
})

export default router
